module.exports = __webpack_public_path__ + "media/images/badges/Linux_icon-45343f657fcdf03505a63e19542fad4f.svg";